// Band to genre mapping
// When a product has a band: tag, genre is auto-assigned from this map
// No need to tag genre separately in Shopify — just add the band: tag
// Add new bands here as you add products

const GENRE_MAP = {
  // Thrash Metal
  'Kreator': 'Thrash Metal',
  'Megadeth': 'Thrash Metal',
  'Slayer': 'Thrash Metal',

  // Heavy Metal / Classic Metal
  'Iron Maiden': 'Heavy Metal',
  'Judas Priest': 'Heavy Metal',

  // Death Metal
  'Amon Amarth': 'Melodic Death Metal',
  'Arch Enemy': 'Melodic Death Metal',
  'In Flames': 'Melodic Death Metal',
  'Obscura': 'Technical Death Metal',
  'Behemoth': 'Blackened Death Metal',
  'Miscreation': 'Death Metal',

  // Groove Metal
  'Pantera': 'Groove Metal',
  'Lamb of God': 'Groove Metal',

  // Progressive Metal
  'Gojira': 'Progressive Metal',
  'Dream Theater': 'Progressive Metal',
  'Opeth': 'Progressive Metal',
  'Tool': 'Progressive Metal',
  'Mastodon': 'Progressive Metal',
  'Trivium': 'Progressive Metal',

  // Metalcore / Post-Metal
  'As I Lay Dying': 'Metalcore',
  'Killswitch Engage': 'Metalcore',
  'BFMV': 'Metalcore',
  'Asking Alexandria': 'Metalcore',
  'Converge': 'Metalcore',

  // Deathcore
  'Chelsea Grin': 'Deathcore',
  'Lorna Shore': 'Deathcore',
  'Suicide Silence': 'Deathcore',
  'Thy Art Is Murder': 'Deathcore',

  // Hardcore / Beatdown
  'Knocked Loose': 'Hardcore',
  'Varials': 'Hardcore',

  // BMTH
  'BMTH': 'Alternative Metal',

  // Atmospheric / Post-Metal
  'KAUAN': 'Atmospheric Metal',
  'Agriculture': 'Post-Metal',
  'Trespasser': 'Black Metal',

  // Other
  'Kuryong': 'Experimental Metal',
  'La Poexe': 'Experimental Metal',
};

export default GENRE_MAP;
